<template>
  <div>
    <report-summary :cells="cells" />
    <report-custom-legend :items="customLegend" />
    <report-graph :chartData="chartData" />
    <report-block-row :items="reportBlockItems" />
  </div>
</template>

<script>
import complianceReportMixin from "@/views/reports/OBV/mixins/complianceReport";

export default {
  mixins: [complianceReportMixin],
  data() {
    return {
      compatibleReportId: 8,
      reportFilters: [
        "timeframe",
        "locations",
        "shifts",
        "hygieneProtocolOpportunities",
        "obvJobRoles",
        "observableUnits"
      ],
      hiddenReportActions: ["saveSlide"]
    };
  }
};
</script>
